import React, { useState, useRef, useEffect } from "react";


const CityMultiSelectDropdown = ({
  cities = [],
  selected = [],
  onChange,
  loading = false,
  disabled = false,
  placeholder = "Select Cities (optional)",
}) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleOpen = () => {
    if (disabled) return;
    setOpen((prev) => !prev);
    setQuery("");
  };

  const toggleCity = (city) => {
    const next = selected.includes(city)
      ? selected.filter((c) => c !== city)
      : [...selected, city];
    onChange(next);
  };

  const filteredCities = cities.filter((c) =>
    c.toLowerCase().includes(query.toLowerCase())
  );

  const allFilteredSelected =
    filteredCities.length > 0 &&
    filteredCities.every((c) => selected.includes(c));

  const handleSelectAll = () => {
    const next = allFilteredSelected
      ? selected.filter((c) => !filteredCities.includes(c))
      : [...new Set([...selected, ...filteredCities])];
    onChange(next);
  };

  return (
    <div className="relative" ref={containerRef}>
      <button
        type="button"
        onClick={toggleOpen}
        disabled={disabled}
        className={`w-full border border-gray-300 rounded-md px-3 py-2.5 text-left focus:outline-none focus:border-amber-500 transition bg-white flex justify-between items-center text-sm ${
          disabled ? "bg-gray-100 cursor-not-allowed opacity-60" : ""
        }`}
      >
        <span className={selected.length ? "text-gray-900" : "text-gray-400"}>
          {loading
            ? "Loading cities..."
            : selected.length > 0
              ? selected.join(", ")
              : placeholder}
        </span>
        <span className="text-gray-400 text-xs">▼</span>
      </button>

      {open && (
        <div className="absolute z-10 mt-1 w-full bg-white border-2 border-gray-200 rounded-lg shadow-lg max-h-72 flex flex-col">
          <div className="p-2 border-b border-gray-100">
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search cities..."
              className="w-full border border-gray-300 rounded-md px-3 py-1.5 text-sm focus:outline-none focus:border-amber-500"
              autoFocus
            />
          </div>

          <div className="overflow-y-auto flex-1">
            {filteredCities.length === 0 ? (
              <p className="px-4 py-3 text-sm text-gray-400 text-center">
                No cities found
              </p>
            ) : (
              <>
                <label className="flex items-center gap-2 px-4 py-2 hover:bg-amber-50 cursor-pointer text-sm font-medium border-b border-gray-100">
                  <input
                    type="checkbox"
                    checked={allFilteredSelected}
                    onChange={handleSelectAll}
                    className="w-4 h-4 text-amber-600 rounded focus:ring-amber-500 cursor-pointer"
                  />
                  Select All
                </label>
                {filteredCities.map((city) => (
                  <label
                    key={city}
                    className="flex items-center gap-2 px-4 py-2 hover:bg-amber-50 cursor-pointer text-sm"
                  >
                    <input
                      type="checkbox"
                      checked={selected.includes(city)}
                      onChange={() => toggleCity(city)}
                      className="w-4 h-4 text-amber-600 rounded focus:ring-amber-500 cursor-pointer"
                    />
                    {city}
                  </label>
                ))}
              </>
            )}
          </div>

          <div className="border-t border-gray-100 p-2">
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="w-full text-center text-amber-600 hover:text-amber-700 text-sm font-medium py-1"
            >
              Done
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CityMultiSelectDropdown;